<template>
  <section class="game-container flex justify-center">
    <div
      class="game-box"
      :class="{
        mobile: $device.mobile,
        desktop: !$device.mobile,
        horizontal: getSelectedDirection === 'horizontal',
        vertical: getSelectedDirection === 'vertical',
      }"
    >
      <img
        class="background left"
        src="@assets/img/allgame/background-left.png"
      />
      <img
        class="background right"
        src="@assets/img/allgame/background-right.png"
      />
      <iframe
        class="game-iframe"
        ref="gameFrame"
        scrolling="no"
        id="iframe"
        :src="`${process.env.VUE_APP_GAME_URL}/${getDirection()}/`"
        allow="fullscreen"
      ></iframe>
    </div>
  </section>
</template>
<script>
import { AuthActions, AuthMutations, AuthNamespace } from "@/store/auth";
import {
  MachineActions,
  MachineMutations,
  MachineNamespace,
} from "@/store/machine";
import { mapActions, mapGetters, mapMutations } from "vuex";

import machineMixin from "@/mixins/machineMixin";
import EventBus from "@/utils/EventBus";

export default {
  mixins: [machineMixin],
  components: {},
  props: {},
  data() {
    return {
      platFormType: false, // [ false = Desktop, true = Mobile ]
      denied: false,
      move_router_path: null,
      move_machine_id: null,
      dummy_machine_id_list: ["8abcab0b-bed0-4521-9804-cbea60e78d9e"],
      player_ban: false, // kick out ?곹깭媛?
      fullScreen: true,
      aspectRatio: 16 / 9,
    };
  },

  watch: {
    // ?ъ슜??currency ?뺣낫 ?낅뜲?댄듃 observer
    getUserCurrency() {
      this.$refs.gameFrame.contentWindow.postMessage(
        {
          functionName: "GetCurrencyList",
          data: {
            code: this.getUserCurrency,
          },
        },
        "*"
      );
    },
  },

  computed: {
    ...mapGetters(AuthNamespace, [
      "getExternalToken",
      "getPlayerId",
      "getUserCurrency",
      "getTokenExpiry",
    ]),

    ...mapGetters(MachineNamespace, ["getMachineId"]),
  },

  beforeDestroy() {
    // iframe message 由ъ뒪???쒓굅
    window.removeEventListener("message", this.receiveMessage);
  },

  // 釉뚮씪?곗? ?ㅻ줈媛湲?踰꾪듉 ?대┃???몄텧 ?대깽??
  beforeRouteLeave(to, from, next) {
    // console.log("beforeRouteLeave");
    this.movePageEvent();
    next(false);
    return "";
  },

  mounted() {
    this.changeFullSize();
    EventBus.$on("movePageEvent", this.movePageEvent);

    // iframe message 由ъ뒪??異붽?
    window.addEventListener("message", this.receiveMessage);

    // 釉뚮씪?곗? ?ш린 蹂寃????몄텧
    this.updateHeight();
    window.addEventListener("resize", this.updateHeight);

    // ?뚮옯???뺤씤 (?곗뒪?ы넲, 紐⑤컮??
    // if (
    //   /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    //     navigator.userAgent,
    //   )
    // ) {
    //   this.platFormType = true; // 紐⑤컮???뚮옯??
    // }
  },

  methods: {
    ...mapActions(AuthNamespace, {
      ACTION_AUTH_LOGOUT: AuthActions.ACTION_AUTH_LOGOUT,
    }),

    ...mapMutations(AuthNamespace, {
      MUTATION_UPDATE_AFK_INFO: AuthMutations.MUTATION_UPDATE_AFK_INFO,
    }),

    ...mapActions(MachineNamespace, {
      ACTION_CREATE_MACHINE_PLAYER: MachineActions.ACTION_CREATE_MACHINE_PLAYER,
      ACTION_DELETE_MACHINE_PLAYER: MachineActions.ACTION_DELETE_MACHINE_PLAYER,
    }),

    ...mapMutations(MachineNamespace, {
      MUTATION_MACHINE_KICK_OFF: MachineMutations.MUTATION_MACHINE_KICK_OFF,
      MUTATION_USER_MACHINE: MachineMutations.MUTATION_USER_MACHINE,
    }),

    getDirection() {
      let direction = "horizontal";
      if (this.$device.mobile) direction = this.getSelectedDirection;

      return direction === "vertical" ? "mobile" : "desktop";
    },

    // 寃뚯엫 ?대씪?댁뼵?몃줈遺???꾨떖諛쏆? 以鍮꾩셿猷?硫붿떆吏
    receiveMessage(e) {
      this.player_ban = false;

      switch (e.data.functionName) {
        case "ReceiveGameState":
          e.source.postMessage(
            {
              functionName: "ReceiveGameState",
              data: {
                token: this.getExternalToken,
                machine_id: this.getMachineId,
                currency: this.getUserCurrency,
              },
            },
            "*"
          );
          break;

        case "MoveToMain":
          this.closeGame();
          break;

        case "KickToMain":
          this.MUTATION_MACHINE_KICK_OFF(true);
          this.closeGame();
          break;

        // AFK Kicked Out
        case "KickToMainAfk":
          this.MUTATION_UPDATE_AFK_INFO(
            e.data.params && e.data.params.length > 0 ? e.data.params[0] : 0
          );
          this.closeGame();
          break;

        case "BanToMain":
          this.player_ban = true;
          this.closeGame();
          break;

        case "requestFullScreen":
          // ?꾩껜?붾㈃ ?ㅼ젙
          this.fullScreen = true;
          this.changeFullSize();
          break;

        case "exitFullScreen":
          // ?꾩껜?붾㈃ ?댁젣
          this.fullScreen = false;
          this.changeFullSize();
          break;
        default:
          break;
      }
    },

    // 寃뚯엫?댁뿉???섏씠吏 ?대룞 ?대깽??由ъ뒪??
    moveGameEvent(id) {
      const xsMain = document.getElementById("xs_main");
      xsMain.scrollTo(0, 0);
      // 寃뚯엫 ?대룞 ?먮퀎 媛??낅뜲?댄듃
      this.move_machine_id = id;
      this.sendPostMessage();
    },

    changeFullSize() {
      const newTemplate = `
      "main"
      "main"
      "main"
    `;
      const main = document.getElementById("x-slot");
      const header = document.getElementById("xs_header");
      const footer = document.getElementById("xs_footer");

      main.style.gridTemplateAreas = newTemplate;
      main.style.gridTemplateRows = "1fr";
      main.style.padding = "0";

      header.style.display = "none";
      footer.style.display = "none";
    },

    // ?섏씠吏 ?대룞 ?대깽??由ъ뒪??
    movePageEvent(path) {
      const xsMain = document.getElementById("xs_main");
      xsMain.scrollTo(0, 0);
      this.move_router_path = path;
      this.sendPostMessage();
    },

    // iframe postMessage ?꾨떖
    sendPostMessage() {
      this.$refs.gameFrame.contentWindow.postMessage(
        { functionName: "OpenCreditOutPopup" },
        "*"
      );
    },

    // 寃뚯엫 醫낅즺
    async closeGame() {
      if (new Date(this.getTokenExpiry) < new Date()) {
        alert("Your login session was expired.");
        this.ACTION_AUTH_LOGOUT();
        this.moveRouterPath("/");
        return;
      }

      if (this.player_ban) {
        this.moveRouterPath("/");
        return;
      }

      const machine_id = this.getMachineId;
      const player_id = this.getPlayerId;
      const external_token = this.getExternalToken;

      // ?좏깮??癒몄떊???ъ슜???뺣낫 ??젣
      this.ACTION_DELETE_MACHINE_PLAYER({
        machine_id,
        player_id,
        external_token,
      }).then((res) => {
        if (res.status === 200 || res.status === 404) {
          // 癒몄떊 ID媛 議댁옱?섍퀬 ?뚮젅?댁뼱 Kick Off媛 ?꾨땶 寃쎌슦
          if (this.move_machine_id !== null) {
            this.$refs.gameGroupForm.createMachinePlayer(this.move_machine_id);
            return;
          }

          let replace_path = "/";
          switch (this.move_router_path) {
            // 濡쒓렇?꾩썐
            case "logout":
              this.ACTION_AUTH_LOGOUT();
              break;
            // all-game ?대룞
            case "/all-games":
              replace_path = "/all-games";
              break;
            default:
              break;
          }

          this.moveRouterPath(replace_path);
        }
      });
    },

    moveRouterPath(path) {
      this.MUTATION_USER_MACHINE(undefined); // 癒몄떊 ID ?쒓굅
      window.location.replace(path);
    },

    getActualViewportHeight() {
      if (window.visualViewport) {
        return window.visualViewport.height;
      }
      return window.innerHeight;
    },

    updateHeight() {
      const actualHeight = Math.floor10(
        this.getActualViewportHeight() / 100,
        1
      );
      const actualWidth = Math.floor10(window.innerWidth / 100, 1);
      document.documentElement.style.setProperty(
        "--actual-vh",
        `${actualHeight}px`
      );
      document.documentElement.style.setProperty(
        "--actual-vw",
        `${actualWidth}px`
      );
      document.documentElement.style.height = `calc(var(--actual-vh, 1vh) * 100)`;
      document.documentElement.style.maxHeight = `calc(var(--actual-vh, 1vh) * 100)`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/import.scss";

.game-container {
  position: relative;
  width: 100%;
  height: calc(var(--actual-vh, 1vh) * 100);
  background-color: black;
  overflow: hidden;

  img.background {
    position: absolute;
    height: 100%;
    top: 0;
  }
  img.background.left {
    right: 100%;
  }
  img.background.right {
    left: 100%;
  }

  .game-box {
    position: relative;
    width: 100%;
    height: 100%;
    object-fit: contain;

    //PC?섍꼍?멸꼍??contain?쇰줈 ?숈옉?섎룄濡??묒꽦
    @include device-desktop() {
      max-width: calc(100vh * 1.77);
      height: calc(100vw * 0.56);
      max-height: 100vh;
    }

    .game-iframe {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    //紐⑤컮?쇱뿉???몃줈媛 ??湲??섍꼍?멸꼍??
    @include device-lte-tablet() {
      @media (min-height: 70vw) {
        &.horizontal {
          width: calc(1vw * 100);
          height: calc(1vh * 100);
          max-width: calc(1vh * 720 / 1280 * 100);
          max-height: calc(1vw * 1280 / 720 * 100);
          .game-iframe {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%) rotate(90deg) scale(0.5);
            width: calc(var(--actual-vh, 1vh) * 100 * 2);
            height: calc(var(--actual-vw, 1vw) * 100 * 2);
            max-width: calc(var(--actual-vw, 1vw) * 1280 / 720 * 100 * 2);
            max-height: calc(var(--actual-vh, 1vh) * 720 / 1280 * 100 * 2);
          }
        }
      }
    }
  }
}
</style>

